"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ComparisonDataDisplay = require("../ComparisonDataDisplay.styled");
var _useLocalTheme = _interopRequireDefault(require("../../../hooks/useLocalTheme"));
var _SpecBoxContent = _interopRequireDefault(require("./SpecBoxContent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SpecBox = _ref => {
  var _spec$values$productI;
  let {
    spec,
    index,
    rowPlacement,
    productId,
    showAllProducts,
    displayedProducts,
    applyShowDifferences,
    label
  } = _ref;
  const shouldAddTableBorders = (0, _useLocalTheme.default)(`comparison.addTableBorders`, false);
  return /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.StyledGridColumn, {
    key: rowPlacement,
    col: showAllProducts ? 4 : 6,
    shouldAddTableBorders: shouldAddTableBorders
  }, /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.VerticalExpandingWrapper, null, /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.DataEntryWrapper, {
    "data-test-id": `features-values-${index}-${displayedProducts.indexOf(productId)}`
  }, /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.StyledSpecGridRow, {
    marginTop: 2,
    marginBottom: 2
  }, (_spec$values$productI = spec.values[productId]) === null || _spec$values$productI === void 0 ? void 0 : _spec$values$productI.map((value, valueIndex) => {
    return /*#__PURE__*/_react.default.createElement(_SpecBoxContent.default, {
      key: valueIndex,
      spec: spec,
      productId: productId,
      value: value,
      showAllProducts: showAllProducts,
      applyShowDifferences: applyShowDifferences,
      label: label
    });
  })))));
};
var _default = SpecBox;
exports.default = _default;